<template>
    <span>
        <v-autocomplete v-model="category" :items="categories" label="Category" :error-messages="errorMessages" item-text="holeName" item-value="CAT_ID" />
    </span>
</template>

<script>
    export default {
        name: 'CategorySelect',
        props: ['value','errorMsg'],
        components: {},
        data: function() {
            return	{
                category : null
            }
        },


        created(){
            this.category = this.value;
        },

        computed :{
            categories(){
                let result = this.$store.state.categories;
                result.map(item=>{
                    item.holeName = this.getHoleName(item.CAT_ID,result);
                });
                return result;
            },

            errorMessages(){
                let result = [];
                if(this.errorMsg){
                    result.push(this.errorMsg);
                }
                return result;
            }
        },

        watch:{
            value(newValue){
                this.category = newValue;
            },

            category(newValue){
                if(newValue!=this.value){
                    this.$emit("input",newValue);
                }
            }
        },

        methods:{
            addChildCategories(array,parent,preText){
                 let categories = this.$store.state.categories.filter(item=>{
                    return item.CAT_PARENT_ID == parent.CAT_ID
                });
                categories = categories.sort((item1,item2)=>{
                    return (item1.CAT_NAME+"").localeCompare(item2.CAT_NAME+"");
                });
                categories.forEach(element => {
                    let item = {CAT_ID:element.CAT_ID,CAT_NAME:preText+' -> '+element.CAT_NAME}
                    array.push(item);
                    this.addChildCategories(array,element,preText+"-----");
                });
            },

            getHoleName(catId,categories){
                let result = ""
                
                for (let index = 0; index < categories.length; index++) {
                    const element =  categories[index];
                     if(element.CAT_ID == catId){
                         if(element.CAT_PARENT_ID){
                             return this.getHoleName(element.CAT_PARENT_ID,categories)+"."+element.CAT_NAME;
                         } else{
                            return  element.CAT_NAME;
                         }
                        
                    }
                }                 
                return result;
            }
        },
    }
</script>

<style scoped>

</style>
